module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_2-33312773aeccedf54bdc27a3634bf5e6.png";